export const PUBSUB_INSTANCE = '@instance/pubsub'
